import { languageMap } from ".."

languageMap.basic = {
	comments: {
		line: "!",
	},
}
